import React from 'react';

const usFlag = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="#F5F5F5" />
    <rect width="1876" height="988" transform="translate(-1490 -900)" fill="white" />
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#F0F0F0"
    />
    <path
      d="M9.56445 9.99995H19.9992C19.9992 9.09737 19.8789 8.22299 19.6547 7.39124H9.56445V9.99995Z"
      fill="#D80027"
    />
    <path
      d="M9.56445 4.78266H18.5315C17.9193 3.78375 17.1366 2.90083 16.2241 2.17395H9.56445V4.78266Z"
      fill="#D80027"
    />
    <path
      d="M10.0002 20C12.3537 20 14.5169 19.1865 16.2251 17.826H3.77539C5.48359 19.1865 7.64676 20 10.0002 20Z"
      fill="#D80027"
    />
    <path
      d="M1.46699 15.2174H18.5315C19.023 14.4154 19.4041 13.5389 19.6548 12.6086H0.34375C0.594414 13.5389 0.975547 14.4154 1.46699 15.2174Z"
      fill="#D80027"
    />
    <path
      d="M4.63219 1.56164H5.54348L4.69582 2.17746L5.01961 3.17391L4.17199 2.55809L3.32437 3.17391L3.60406 2.31309C2.85773 2.93477 2.20359 3.66313 1.66453 4.47469H1.95652L1.41695 4.86668C1.33289 5.00691 1.25227 5.14937 1.175 5.29395L1.43266 6.08695L0.951953 5.7377C0.832461 5.99086 0.723164 6.24973 0.624922 6.51398L0.908789 7.38773H1.95652L1.10887 8.00356L1.43266 9L0.585039 8.38418L0.0773047 8.75309C0.0264844 9.1616 0 9.57769 0 10H10C10 4.47719 10 3.82609 10 0C8.02453 0 6.18301 0.573047 4.63219 1.56164ZM5.01961 9L4.17199 8.38418L3.32437 9L3.64816 8.00356L2.80051 7.38773H3.84824L4.17199 6.39129L4.49574 7.38773H5.54348L4.69582 8.00356L5.01961 9ZM4.69582 5.09051L5.01961 6.08695L4.17199 5.47113L3.32437 6.08695L3.64816 5.09051L2.80051 4.47469H3.84824L4.17199 3.47824L4.49574 4.47469H5.54348L4.69582 5.09051ZM8.60656 9L7.75895 8.38418L6.91133 9L7.23512 8.00356L6.38746 7.38773H7.4352L7.75895 6.39129L8.0827 7.38773H9.13043L8.28277 8.00356L8.60656 9ZM8.28277 5.09051L8.60656 6.08695L7.75895 5.47113L6.91133 6.08695L7.23512 5.09051L6.38746 4.47469H7.4352L7.75895 3.47824L8.0827 4.47469H9.13043L8.28277 5.09051ZM8.28277 2.17746L8.60656 3.17391L7.75895 2.55809L6.91133 3.17391L7.23512 2.17746L6.38746 1.56164H7.4352L7.75895 0.565195L8.0827 1.56164H9.13043L8.28277 2.17746Z"
      fill="#0052B4"
    />
  </svg>
);

const ukFlag = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="#F5F5F5" />
    <rect width="1876" height="988" transform="translate(-1222 -900)" fill="white" />
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#F0F0F0"
    />
    <path
      d="M2.06645 3.91174C1.28094 4.93374 0.688633 6.11167 0.34375 7.39131H5.54602L2.06645 3.91174Z"
      fill="#0052B4"
    />
    <path
      d="M19.6553 7.3914C19.3104 6.11179 18.7181 4.93386 17.9326 3.91187L14.4531 7.3914H19.6553Z"
      fill="#0052B4"
    />
    <path
      d="M0.34375 12.6088C0.688672 13.8884 1.28098 15.0663 2.06645 16.0883L5.5459 12.6088H0.34375Z"
      fill="#0052B4"
    />
    <path
      d="M16.0889 2.06722C15.0669 1.28171 13.889 0.689404 12.6094 0.344482V5.54671L16.0889 2.06722Z"
      fill="#0052B4"
    />
    <path
      d="M3.91211 17.9328C4.9341 18.7183 6.11203 19.3106 7.39164 19.6556V14.4534L3.91211 17.9328Z"
      fill="#0052B4"
    />
    <path
      d="M7.3916 0.344482C6.11199 0.689404 4.93406 1.28171 3.91211 2.06718L7.3916 5.54667V0.344482Z"
      fill="#0052B4"
    />
    <path
      d="M12.6094 19.6556C13.889 19.3106 15.0669 18.7183 16.0889 17.9329L12.6094 14.4534V19.6556Z"
      fill="#0052B4"
    />
    <path
      d="M14.4531 12.6088L17.9326 16.0883C18.7181 15.0663 19.3104 13.8884 19.6553 12.6088H14.4531Z"
      fill="#0052B4"
    />
    <path
      d="M19.9154 8.69566H11.3044H11.3044V0.0846484C10.8774 0.0290625 10.4421 0 10 0C9.55785 0 9.12262 0.0290625 8.69566 0.0846484V8.69559V8.69563H0.0846484C0.0290625 9.12262 0 9.55793 0 10C0 10.4421 0.0290625 10.8774 0.0846484 11.3043H8.69559H8.69563V19.9154C9.12262 19.9709 9.55785 20 10 20C10.4421 20 10.8774 19.971 11.3043 19.9154V11.3044V11.3044H19.9154C19.9709 10.8774 20 10.4421 20 10C20 9.55793 19.9709 9.12262 19.9154 8.69566Z"
      fill="#D80027"
    />
    <path
      d="M12.6094 12.6088L17.0717 17.0711C17.277 16.866 17.4727 16.6515 17.6595 16.4292L13.8391 12.6088H12.6094V12.6088Z"
      fill="#D80027"
    />
    <path
      d="M7.39207 12.6088H7.39199L2.92969 17.0711C3.13484 17.2763 3.34934 17.4721 3.57168 17.6589L7.39207 13.8384V12.6088Z"
      fill="#D80027"
    />
    <path
      d="M7.39195 7.39142V7.39134L2.92961 2.92896C2.72438 3.13411 2.52859 3.3486 2.3418 3.57095L6.16223 7.39138L7.39195 7.39142Z"
      fill="#D80027"
    />
    <path
      d="M12.6094 7.39138L17.0718 2.92896C16.8666 2.72373 16.6521 2.52794 16.4298 2.34119L12.6094 6.16162V7.39138Z"
      fill="#D80027"
    />
  </svg>
);

const italyFlag = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="#F5F5F5" />
    <rect width="1876" height="988" transform="translate(-284 -432)" fill="white" />
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#F0F0F0"
    />
    <path
      d="M20.0003 9.99996C20.0003 5.70031 17.2865 2.03488 13.4785 0.621948V19.378C17.2865 17.965 20.0003 14.2996 20.0003 9.99996Z"
      fill="#D80027"
    />
    <path
      d="M0 9.99996C0 14.2996 2.71375 17.965 6.52176 19.378V0.621948C2.71375 2.03488 0 5.70031 0 9.99996Z"
      fill="#6DA544"
    />
  </svg>
);

const spanishFlag = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="#F5F5F5" />
    <rect width="1876" height="988" transform="translate(-1088 -796)" fill="white" />
    <path
      d="M0 10C0 11.2232 0.220039 12.395 0.621992 13.4783L10 14.3478L19.378 13.4783C19.78 12.395 20 11.2232 20 10C20 8.77683 19.78 7.60511 19.378 6.52179L10 5.65222L0.621992 6.52179C0.220039 7.60511 0 8.77683 0 10Z"
      fill="#FFDA44"
    />
    <path
      d="M19.3781 6.52176C17.9652 2.71379 14.2997 0 10.0001 0C5.70043 0 2.035 2.71379 0.62207 6.52176H19.3781Z"
      fill="#D80027"
    />
    <path
      d="M0.62207 13.4783C2.035 17.2862 5.70043 20 10.0001 20C14.2997 20 17.9652 17.2862 19.3781 13.4783H0.62207Z"
      fill="#D80027"
    />
  </svg>
);

const frFlag = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="#F5F5F5" />
    <rect width="1876" height="988" transform="translate(-1758 -276)" fill="white" />
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#F0F0F0"
    />
    <path
      d="M20.0003 10C20.0003 5.70037 17.2865 2.03494 13.4785 0.622009V19.3781C17.2865 17.9651 20.0003 14.2997 20.0003 10Z"
      fill="#D80027"
    />
    <path
      d="M0 10C0 14.2997 2.71379 17.9651 6.52176 19.378V0.622009C2.71379 2.03494 0 5.70037 0 10Z"
      fill="#0052B4"
    />
  </svg>
);

const deFlag = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" fill="#F5F5F5" />
    <rect width="1876" height="988" transform="translate(-686 -328)" fill="white" />
    <path
      d="M0.621094 13.4782C2.03402 17.2862 5.69945 20 9.9991 20C14.2987 20 17.9642 17.2862 19.3771 13.4782L9.9991 12.6087L0.621094 13.4782Z"
      fill="#FFDA44"
    />
    <path
      d="M9.9991 0C5.69945 0 2.03402 2.71375 0.621094 6.52175L9.9991 7.39129L19.3771 6.52172C17.9642 2.71375 14.2987 0 9.9991 0Z"
      fill="black"
    />
    <path
      d="M0.621992 6.52173C0.220039 7.60505 0 8.77677 0 9.99997C0 11.2232 0.220039 12.3949 0.621992 13.4782H19.378C19.78 12.3949 20 11.2232 20 9.99997C20 8.77677 19.78 7.60505 19.378 6.52173H0.621992Z"
      fill="#D80027"
    />
  </svg>
);

export { usFlag, ukFlag, italyFlag, spanishFlag, frFlag, deFlag };
